import { InjectionToken } from '@angular/core';
import { RxState } from '@rx-angular/state';
import { AppState } from '@rx-lib/models';

export const STORE = new InjectionToken<RxState<AppState>>(
  'STORE'
);